/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    AllFiltersOutput,
    AllFiltersOutputFromJSON,
    AllFiltersOutputToJSON,
    AllInOneUpdateInput,
    AllInOneUpdateInputFromJSON,
    AllInOneUpdateInputToJSON,
    CabinClassType,
    CabinClassTypeFromJSON,
    CabinClassTypeToJSON,
    CreateMarkupInput,
    CreateMarkupInputFromJSON,
    CreateMarkupInputToJSON,
    FareType,
    FareTypeFromJSON,
    FareTypeToJSON,
    JourneyType,
    JourneyTypeFromJSON,
    JourneyTypeToJSON,
    MarkupOutput,
    MarkupOutputFromJSON,
    MarkupOutputToJSON,
    MarkupOutputIEnumerableBusinessDataResponse,
    MarkupOutputIEnumerableBusinessDataResponseFromJSON,
    MarkupOutputIEnumerableBusinessDataResponseToJSON,
    PriorityType,
    PriorityTypeFromJSON,
    PriorityTypeToJSON,
    ProblemDetails,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
} from '../models';

export interface GetByIdRequest {
    id: string;
}

export interface MarkupsExportGetRequest {
    accountCode?: string;
    airportCode?: string;
    bookingClass?: string;
    bookingDateTime?: Date;
    bookingPrice?: number;
    cabinClass?: CabinClassType;
    cityCode?: string;
    countryCode?: string;
    description?: string;
    destination?: string;
    destinationIsCityCode?: boolean;
    fareBasisCode?: string;
    fareType?: FareType;
    flightNumber?: string;
    id?: string;
    showDeleted?: boolean;
    showDisabled?: boolean;
    isExclusionRule?: boolean;
    journeyType?: JourneyType;
    marketingAirline?: string;
    markupAmount?: number;
    markupPercentage?: number;
    origin?: string;
    originIsCityCode?: boolean;
    passengerAge?: number;
    priority?: PriorityType;
    regionCode?: string;
    routeArrivalAirportCode?: string;
    routeArrivalCityCode?: string;
    routeArrivalCountryCode?: string;
    routeArrivalRegionCode?: string;
    routeDepartureAirportCode?: string;
    routeDepartureCityCode?: string;
    routeDepartureCountryCode?: string;
    routeDepartureRegionCode?: string;
    stationCode?: string;
    supplier?: string;
    systemContextAgency?: string;
    systemContextAgencyGroup?: string;
    systemContextBrandAndMarketMarketId?: string;
    systemContextBrandAndMarketMarketLabel?: string;
    systemContextBrandAndMarketMarketEffective?: boolean;
    systemContextBrandAndMarketBrandId?: number;
    systemContextBrandAndMarketBrandLabel?: string;
    systemContextBrandAndMarketBrandEffective?: boolean;
    systemContextBrandAndMarketAllowEdit?: boolean;
    systemContextChannel?: number;
    ticketDesignator?: string;
    travelDateTime?: Date;
    orderByRelevanceAscending?: boolean;
}

export interface MarkupsFiltersGetRequest {
    brand?: number;
    market?: string;
}

export interface MarkupsGetRequest {
    accountCode?: string;
    airportCode?: string;
    bookingClass?: string;
    bookingDateTime?: Date;
    bookingPrice?: number;
    cabinClass?: CabinClassType;
    cityCode?: string;
    countryCode?: string;
    description?: string;
    destination?: string;
    destinationIsCityCode?: boolean;
    fareBasisCode?: string;
    fareType?: FareType;
    flightNumber?: string;
    id?: string;
    showDeleted?: boolean;
    showDisabled?: boolean;
    isExclusionRule?: boolean;
    journeyType?: JourneyType;
    marketingAirline?: string;
    markupAmount?: number;
    markupPercentage?: number;
    origin?: string;
    originIsCityCode?: boolean;
    passengerAge?: number;
    priority?: PriorityType;
    regionCode?: string;
    routeArrivalAirportCode?: string;
    routeArrivalCityCode?: string;
    routeArrivalCountryCode?: string;
    routeArrivalRegionCode?: string;
    routeDepartureAirportCode?: string;
    routeDepartureCityCode?: string;
    routeDepartureCountryCode?: string;
    routeDepartureRegionCode?: string;
    stationCode?: string;
    supplier?: string;
    systemContextAgency?: string;
    systemContextAgencyGroup?: string;
    systemContextBrandAndMarketMarketId?: string;
    systemContextBrandAndMarketMarketLabel?: string;
    systemContextBrandAndMarketMarketEffective?: boolean;
    systemContextBrandAndMarketBrandId?: number;
    systemContextBrandAndMarketBrandLabel?: string;
    systemContextBrandAndMarketBrandEffective?: boolean;
    systemContextBrandAndMarketAllowEdit?: boolean;
    systemContextChannel?: number;
    ticketDesignator?: string;
    travelDateTime?: Date;
    orderByRelevanceAscending?: boolean;
    pageNumber?: number;
    pageSize?: number;
}

export interface MarkupsIdDeleteRequest {
    id: string;
}

export interface MarkupsPostRequest {
    createMarkupInput?: CreateMarkupInput;
}

export interface MarkupsPutRequest {
    allInOneUpdateInput?: AllInOneUpdateInput;
}

/**
 * no description
 */
export class MarkupsApi extends runtime.BaseAPI {

    /**
     */
    async getByIdRaw(requestParameters: GetByIdRequest): Promise<runtime.ApiResponse<MarkupOutput>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getById.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/Markups/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => MarkupOutputFromJSON(jsonValue));
    }

    /**
     */
    async getById(requestParameters: GetByIdRequest): Promise<MarkupOutput> {
        const response = await this.getByIdRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async markupsExportGetRaw(requestParameters: MarkupsExportGetRequest): Promise<runtime.ApiResponse<string>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.accountCode !== undefined) {
            queryParameters['AccountCode'] = requestParameters.accountCode;
        }

        if (requestParameters.airportCode !== undefined) {
            queryParameters['AirportCode'] = requestParameters.airportCode;
        }

        if (requestParameters.bookingClass !== undefined) {
            queryParameters['BookingClass'] = requestParameters.bookingClass;
        }

        if (requestParameters.bookingDateTime !== undefined) {
            queryParameters['BookingDateTime'] = (requestParameters.bookingDateTime as any).toISOString();
        }

        if (requestParameters.bookingPrice !== undefined) {
            queryParameters['BookingPrice'] = requestParameters.bookingPrice;
        }

        if (requestParameters.cabinClass !== undefined) {
            queryParameters['CabinClass'] = requestParameters.cabinClass;
        }

        if (requestParameters.cityCode !== undefined) {
            queryParameters['CityCode'] = requestParameters.cityCode;
        }

        if (requestParameters.countryCode !== undefined) {
            queryParameters['CountryCode'] = requestParameters.countryCode;
        }

        if (requestParameters.description !== undefined) {
            queryParameters['Description'] = requestParameters.description;
        }

        if (requestParameters.destination !== undefined) {
            queryParameters['Destination'] = requestParameters.destination;
        }

        if (requestParameters.destinationIsCityCode !== undefined) {
            queryParameters['DestinationIsCityCode'] = requestParameters.destinationIsCityCode;
        }

        if (requestParameters.fareBasisCode !== undefined) {
            queryParameters['FareBasisCode'] = requestParameters.fareBasisCode;
        }

        if (requestParameters.fareType !== undefined) {
            queryParameters['FareType'] = requestParameters.fareType;
        }

        if (requestParameters.flightNumber !== undefined) {
            queryParameters['FlightNumber'] = requestParameters.flightNumber;
        }

        if (requestParameters.id !== undefined) {
            queryParameters['Id'] = requestParameters.id;
        }

        if (requestParameters.showDeleted !== undefined) {
            queryParameters['ShowDeleted'] = requestParameters.showDeleted;
        }

        if (requestParameters.showDisabled !== undefined) {
            queryParameters['ShowDisabled'] = requestParameters.showDisabled;
        }

        if (requestParameters.isExclusionRule !== undefined) {
            queryParameters['IsExclusionRule'] = requestParameters.isExclusionRule;
        }

        if (requestParameters.journeyType !== undefined) {
            queryParameters['JourneyType'] = requestParameters.journeyType;
        }

        if (requestParameters.marketingAirline !== undefined) {
            queryParameters['MarketingAirline'] = requestParameters.marketingAirline;
        }

        if (requestParameters.markupAmount !== undefined) {
            queryParameters['MarkupAmount'] = requestParameters.markupAmount;
        }

        if (requestParameters.markupPercentage !== undefined) {
            queryParameters['MarkupPercentage'] = requestParameters.markupPercentage;
        }

        if (requestParameters.origin !== undefined) {
            queryParameters['Origin'] = requestParameters.origin;
        }

        if (requestParameters.originIsCityCode !== undefined) {
            queryParameters['OriginIsCityCode'] = requestParameters.originIsCityCode;
        }

        if (requestParameters.passengerAge !== undefined) {
            queryParameters['PassengerAge'] = requestParameters.passengerAge;
        }

        if (requestParameters.priority !== undefined) {
            queryParameters['Priority'] = requestParameters.priority;
        }

        if (requestParameters.regionCode !== undefined) {
            queryParameters['RegionCode'] = requestParameters.regionCode;
        }

        if (requestParameters.routeArrivalAirportCode !== undefined) {
            queryParameters['RouteArrivalAirportCode'] = requestParameters.routeArrivalAirportCode;
        }

        if (requestParameters.routeArrivalCityCode !== undefined) {
            queryParameters['RouteArrivalCityCode'] = requestParameters.routeArrivalCityCode;
        }

        if (requestParameters.routeArrivalCountryCode !== undefined) {
            queryParameters['RouteArrivalCountryCode'] = requestParameters.routeArrivalCountryCode;
        }

        if (requestParameters.routeArrivalRegionCode !== undefined) {
            queryParameters['RouteArrivalRegionCode'] = requestParameters.routeArrivalRegionCode;
        }

        if (requestParameters.routeDepartureAirportCode !== undefined) {
            queryParameters['RouteDepartureAirportCode'] = requestParameters.routeDepartureAirportCode;
        }

        if (requestParameters.routeDepartureCityCode !== undefined) {
            queryParameters['RouteDepartureCityCode'] = requestParameters.routeDepartureCityCode;
        }

        if (requestParameters.routeDepartureCountryCode !== undefined) {
            queryParameters['RouteDepartureCountryCode'] = requestParameters.routeDepartureCountryCode;
        }

        if (requestParameters.routeDepartureRegionCode !== undefined) {
            queryParameters['RouteDepartureRegionCode'] = requestParameters.routeDepartureRegionCode;
        }

        if (requestParameters.stationCode !== undefined) {
            queryParameters['StationCode'] = requestParameters.stationCode;
        }

        if (requestParameters.supplier !== undefined) {
            queryParameters['Supplier'] = requestParameters.supplier;
        }

        if (requestParameters.systemContextAgency !== undefined) {
            queryParameters['SystemContextAgency'] = requestParameters.systemContextAgency;
        }

        if (requestParameters.systemContextAgencyGroup !== undefined) {
            queryParameters['SystemContextAgencyGroup'] = requestParameters.systemContextAgencyGroup;
        }

        if (requestParameters.systemContextBrandAndMarketMarketId !== undefined) {
            queryParameters['SystemContextBrandAndMarket.Market.Id'] = requestParameters.systemContextBrandAndMarketMarketId;
        }

        if (requestParameters.systemContextBrandAndMarketMarketLabel !== undefined) {
            queryParameters['SystemContextBrandAndMarket.Market.Label'] = requestParameters.systemContextBrandAndMarketMarketLabel;
        }

        if (requestParameters.systemContextBrandAndMarketMarketEffective !== undefined) {
            queryParameters['SystemContextBrandAndMarket.Market.Effective'] = requestParameters.systemContextBrandAndMarketMarketEffective;
        }

        if (requestParameters.systemContextBrandAndMarketBrandId !== undefined) {
            queryParameters['SystemContextBrandAndMarket.Brand.Id'] = requestParameters.systemContextBrandAndMarketBrandId;
        }

        if (requestParameters.systemContextBrandAndMarketBrandLabel !== undefined) {
            queryParameters['SystemContextBrandAndMarket.Brand.Label'] = requestParameters.systemContextBrandAndMarketBrandLabel;
        }

        if (requestParameters.systemContextBrandAndMarketBrandEffective !== undefined) {
            queryParameters['SystemContextBrandAndMarket.Brand.Effective'] = requestParameters.systemContextBrandAndMarketBrandEffective;
        }

        if (requestParameters.systemContextBrandAndMarketAllowEdit !== undefined) {
            queryParameters['SystemContextBrandAndMarket.AllowEdit'] = requestParameters.systemContextBrandAndMarketAllowEdit;
        }

        if (requestParameters.systemContextChannel !== undefined) {
            queryParameters['SystemContextChannel'] = requestParameters.systemContextChannel;
        }

        if (requestParameters.ticketDesignator !== undefined) {
            queryParameters['TicketDesignator'] = requestParameters.ticketDesignator;
        }

        if (requestParameters.travelDateTime !== undefined) {
            queryParameters['TravelDateTime'] = (requestParameters.travelDateTime as any).toISOString();
        }

        if (requestParameters.orderByRelevanceAscending !== undefined) {
            queryParameters['OrderByRelevanceAscending'] = requestParameters.orderByRelevanceAscending;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/Markups/export`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async markupsExportGet(requestParameters: MarkupsExportGetRequest): Promise<string> {
        const response = await this.markupsExportGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async markupsFiltersGetRaw(requestParameters: MarkupsFiltersGetRequest): Promise<runtime.ApiResponse<AllFiltersOutput>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.brand !== undefined) {
            queryParameters['brand'] = requestParameters.brand;
        }

        if (requestParameters.market !== undefined) {
            queryParameters['market'] = requestParameters.market;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/Markups/filters`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => AllFiltersOutputFromJSON(jsonValue));
    }

    /**
     */
    async markupsFiltersGet(requestParameters: MarkupsFiltersGetRequest): Promise<AllFiltersOutput> {
        const response = await this.markupsFiltersGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async markupsGetRaw(requestParameters: MarkupsGetRequest): Promise<runtime.ApiResponse<MarkupOutputIEnumerableBusinessDataResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.accountCode !== undefined) {
            queryParameters['AccountCode'] = requestParameters.accountCode;
        }

        if (requestParameters.airportCode !== undefined) {
            queryParameters['AirportCode'] = requestParameters.airportCode;
        }

        if (requestParameters.bookingClass !== undefined) {
            queryParameters['BookingClass'] = requestParameters.bookingClass;
        }

        if (requestParameters.bookingDateTime !== undefined) {
            queryParameters['BookingDateTime'] = (requestParameters.bookingDateTime as any).toISOString();
        }

        if (requestParameters.bookingPrice !== undefined) {
            queryParameters['BookingPrice'] = requestParameters.bookingPrice;
        }

        if (requestParameters.cabinClass !== undefined) {
            queryParameters['CabinClass'] = requestParameters.cabinClass;
        }

        if (requestParameters.cityCode !== undefined) {
            queryParameters['CityCode'] = requestParameters.cityCode;
        }

        if (requestParameters.countryCode !== undefined) {
            queryParameters['CountryCode'] = requestParameters.countryCode;
        }

        if (requestParameters.description !== undefined) {
            queryParameters['Description'] = requestParameters.description;
        }

        if (requestParameters.destination !== undefined) {
            queryParameters['Destination'] = requestParameters.destination;
        }

        if (requestParameters.destinationIsCityCode !== undefined) {
            queryParameters['DestinationIsCityCode'] = requestParameters.destinationIsCityCode;
        }

        if (requestParameters.fareBasisCode !== undefined) {
            queryParameters['FareBasisCode'] = requestParameters.fareBasisCode;
        }

        if (requestParameters.fareType !== undefined) {
            queryParameters['FareType'] = requestParameters.fareType;
        }

        if (requestParameters.flightNumber !== undefined) {
            queryParameters['FlightNumber'] = requestParameters.flightNumber;
        }

        if (requestParameters.id !== undefined) {
            queryParameters['Id'] = requestParameters.id;
        }

        if (requestParameters.showDeleted !== undefined) {
            queryParameters['ShowDeleted'] = requestParameters.showDeleted;
        }

        if (requestParameters.showDisabled !== undefined) {
            queryParameters['ShowDisabled'] = requestParameters.showDisabled;
        }

        if (requestParameters.isExclusionRule !== undefined) {
            queryParameters['IsExclusionRule'] = requestParameters.isExclusionRule;
        }

        if (requestParameters.journeyType !== undefined) {
            queryParameters['JourneyType'] = requestParameters.journeyType;
        }

        if (requestParameters.marketingAirline !== undefined) {
            queryParameters['MarketingAirline'] = requestParameters.marketingAirline;
        }

        if (requestParameters.markupAmount !== undefined) {
            queryParameters['MarkupAmount'] = requestParameters.markupAmount;
        }

        if (requestParameters.markupPercentage !== undefined) {
            queryParameters['MarkupPercentage'] = requestParameters.markupPercentage;
        }

        if (requestParameters.origin !== undefined) {
            queryParameters['Origin'] = requestParameters.origin;
        }

        if (requestParameters.originIsCityCode !== undefined) {
            queryParameters['OriginIsCityCode'] = requestParameters.originIsCityCode;
        }

        if (requestParameters.passengerAge !== undefined) {
            queryParameters['PassengerAge'] = requestParameters.passengerAge;
        }

        if (requestParameters.priority !== undefined) {
            queryParameters['Priority'] = requestParameters.priority;
        }

        if (requestParameters.regionCode !== undefined) {
            queryParameters['RegionCode'] = requestParameters.regionCode;
        }

        if (requestParameters.routeArrivalAirportCode !== undefined) {
            queryParameters['RouteArrivalAirportCode'] = requestParameters.routeArrivalAirportCode;
        }

        if (requestParameters.routeArrivalCityCode !== undefined) {
            queryParameters['RouteArrivalCityCode'] = requestParameters.routeArrivalCityCode;
        }

        if (requestParameters.routeArrivalCountryCode !== undefined) {
            queryParameters['RouteArrivalCountryCode'] = requestParameters.routeArrivalCountryCode;
        }

        if (requestParameters.routeArrivalRegionCode !== undefined) {
            queryParameters['RouteArrivalRegionCode'] = requestParameters.routeArrivalRegionCode;
        }

        if (requestParameters.routeDepartureAirportCode !== undefined) {
            queryParameters['RouteDepartureAirportCode'] = requestParameters.routeDepartureAirportCode;
        }

        if (requestParameters.routeDepartureCityCode !== undefined) {
            queryParameters['RouteDepartureCityCode'] = requestParameters.routeDepartureCityCode;
        }

        if (requestParameters.routeDepartureCountryCode !== undefined) {
            queryParameters['RouteDepartureCountryCode'] = requestParameters.routeDepartureCountryCode;
        }

        if (requestParameters.routeDepartureRegionCode !== undefined) {
            queryParameters['RouteDepartureRegionCode'] = requestParameters.routeDepartureRegionCode;
        }

        if (requestParameters.stationCode !== undefined) {
            queryParameters['StationCode'] = requestParameters.stationCode;
        }

        if (requestParameters.supplier !== undefined) {
            queryParameters['Supplier'] = requestParameters.supplier;
        }

        if (requestParameters.systemContextAgency !== undefined) {
            queryParameters['SystemContextAgency'] = requestParameters.systemContextAgency;
        }

        if (requestParameters.systemContextAgencyGroup !== undefined) {
            queryParameters['SystemContextAgencyGroup'] = requestParameters.systemContextAgencyGroup;
        }

        if (requestParameters.systemContextBrandAndMarketMarketId !== undefined) {
            queryParameters['SystemContextBrandAndMarket.Market.Id'] = requestParameters.systemContextBrandAndMarketMarketId;
        }

        if (requestParameters.systemContextBrandAndMarketMarketLabel !== undefined) {
            queryParameters['SystemContextBrandAndMarket.Market.Label'] = requestParameters.systemContextBrandAndMarketMarketLabel;
        }

        if (requestParameters.systemContextBrandAndMarketMarketEffective !== undefined) {
            queryParameters['SystemContextBrandAndMarket.Market.Effective'] = requestParameters.systemContextBrandAndMarketMarketEffective;
        }

        if (requestParameters.systemContextBrandAndMarketBrandId !== undefined) {
            queryParameters['SystemContextBrandAndMarket.Brand.Id'] = requestParameters.systemContextBrandAndMarketBrandId;
        }

        if (requestParameters.systemContextBrandAndMarketBrandLabel !== undefined) {
            queryParameters['SystemContextBrandAndMarket.Brand.Label'] = requestParameters.systemContextBrandAndMarketBrandLabel;
        }

        if (requestParameters.systemContextBrandAndMarketBrandEffective !== undefined) {
            queryParameters['SystemContextBrandAndMarket.Brand.Effective'] = requestParameters.systemContextBrandAndMarketBrandEffective;
        }

        if (requestParameters.systemContextBrandAndMarketAllowEdit !== undefined) {
            queryParameters['SystemContextBrandAndMarket.AllowEdit'] = requestParameters.systemContextBrandAndMarketAllowEdit;
        }

        if (requestParameters.systemContextChannel !== undefined) {
            queryParameters['SystemContextChannel'] = requestParameters.systemContextChannel;
        }

        if (requestParameters.ticketDesignator !== undefined) {
            queryParameters['TicketDesignator'] = requestParameters.ticketDesignator;
        }

        if (requestParameters.travelDateTime !== undefined) {
            queryParameters['TravelDateTime'] = (requestParameters.travelDateTime as any).toISOString();
        }

        if (requestParameters.orderByRelevanceAscending !== undefined) {
            queryParameters['OrderByRelevanceAscending'] = requestParameters.orderByRelevanceAscending;
        }

        if (requestParameters.pageNumber !== undefined) {
            queryParameters['pageNumber'] = requestParameters.pageNumber;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/Markups`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => MarkupOutputIEnumerableBusinessDataResponseFromJSON(jsonValue));
    }

    /**
     */
    async markupsGet(requestParameters: MarkupsGetRequest): Promise<MarkupOutputIEnumerableBusinessDataResponse> {
        const response = await this.markupsGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async markupsIdDeleteRaw(requestParameters: MarkupsIdDeleteRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling markupsIdDelete.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/Markups/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async markupsIdDelete(requestParameters: MarkupsIdDeleteRequest): Promise<void> {
        await this.markupsIdDeleteRaw(requestParameters);
    }

    /**
     */
    async markupsPostRaw(requestParameters: MarkupsPostRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/Markups`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateMarkupInputToJSON(requestParameters.createMarkupInput),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async markupsPost(requestParameters: MarkupsPostRequest): Promise<void> {
        await this.markupsPostRaw(requestParameters);
    }

    /**
     */
    async markupsPutRaw(requestParameters: MarkupsPutRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/Markups`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AllInOneUpdateInputToJSON(requestParameters.allInOneUpdateInput),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async markupsPut(requestParameters: MarkupsPutRequest): Promise<void> {
        await this.markupsPutRaw(requestParameters);
    }

}
